module.exports = __webpack_public_path__ + "static/Joanna_Wytrzes_CV-e41302409dc409ae7b545a31c3a96756.pdf";